module.exports = __webpack_public_path__ + "static/img/img_reject.335c329.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img_reject.png
// module id = xMkT
// module chunks = 1